import { render, staticRenderFns } from "./share_app.vue?vue&type=template&id=66e66d3e&scoped=true"
import script from "./share_app.vue?vue&type=script&lang=js"
export * from "./share_app.vue?vue&type=script&lang=js"
import style0 from "./share_app.vue?vue&type=style&index=0&id=66e66d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e66d3e",
  null
  
)

export default component.exports